function RecruiterScene() {
  window.location.replace('https://seekube.hellowork.com/');
}

export default RecruiterScene;
